// 移植自姊妹專案 pixi_slot（FaFaCat 移植案）已驗證的 src/framework/net/crypto/handshake.ts。
// 尚未接上本專案（Slot026）的真實後端，欄位/流程未經本專案實機驗證。
//
// RSA 握手 — 對應 Unity EncryptionHelper.GetKey + Asn1Builder。
// 公鑰匯出為 SubjectPublicKeyInfo (SPKI) DER；伺服器以 RSAES-PKCS#1 v1.5 加密 AES 金鑰回傳，
// 客戶端以私鑰 PKCS#1 v1.5 解密。
//
// 注意：Web Crypto 不支援 RSAES-PKCS#1 v1.5，故改用 node-forge（與後端一致）。
import * as forge from 'node-forge'

export interface RsaKeyPair {
  /** SubjectPublicKeyInfo DER，作為 GetAESKey 的 payload 送出。 */
  readonly publicKeyDer: Uint8Array
  /** 以私鑰 PKCS#1 v1.5 解出伺服器回傳的 AES 金鑰。 */
  decryptAesKey(encrypted: Uint8Array): Uint8Array
}

export function generateRsaKeyPair(): RsaKeyPair {
  const keyPair = forge.pki.rsa.generateKeyPair({ bits: 2048, e: 0x10001 })
  const spkiDer = forge.asn1.toDer(forge.pki.publicKeyToAsn1(keyPair.publicKey)).getBytes()

  return {
    publicKeyDer: binaryStringToBytes(spkiDer),
    decryptAesKey(encrypted: Uint8Array): Uint8Array {
      const encryptedStr = bytesToBinaryString(encrypted)
      const keyStr = keyPair.privateKey.decrypt(encryptedStr, 'RSAES-PKCS1-V1_5')
      return binaryStringToBytes(keyStr)
    },
  }
}

// node-forge 以「binary string」(每字元 = 1 byte) 表示二進位資料。
function bytesToBinaryString(bytes: Uint8Array): string {
  let result = ''
  for (let i = 0; i < bytes.length; i++) {
    result += String.fromCharCode(bytes[i])
  }
  return result
}

function binaryStringToBytes(text: string): Uint8Array {
  const bytes = new Uint8Array(text.length)
  for (let i = 0; i < text.length; i++) {
    bytes[i] = text.charCodeAt(i) & 0xff
  }
  return bytes
}
